<template>
  <div v-for="item in newsdesc" :key="item._id">
    <div class="title">
      <h2>
        {{ item.neName }}
      </h2>
      <hr />
    </div>
    <div class="content">
      <div class="con-top">
        <p>作者：{{ item.neAuthor }}</p>
        <p>时间：{{ item.createAt }}</p>
      </div>
      <div class="con-detail" v-html="item.neBody"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    newsdesc: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.title {
  h2 {
    line-height: 30px;
    text-align: center;
    padding-left: 5px;
    padding-right: 5px;
  }
  hr {
    border: #f5f5f5 solid 1px;
  }
}
.content {
  .con-top {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    p {
      padding-left: 35px;
      color: #777;
    }
  }
  .con-detail {
    width: 850px;
    padding: 15px 15px 20px 15px;
  }
}
</style>
